import { render } from "./manage_entity_type.html?vue&type=template&id=165d61d4&scoped=true&external"
import script from "./manage_entity_type.js?vue&type=script&lang=js&external"
export * from "./manage_entity_type.js?vue&type=script&lang=js&external"

import "./ManageEntityType.vue?vue&type=style&index=0&id=165d61d4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165d61d4"]])

export default __exports__